import React from 'react';
import { FaChevronLeft, FaChevronRight, FaRedo, FaSpinner } from 'react-icons/fa';
import { ViewMode } from '../hooks/usePlantafel';
import styles from './PlantafelBoard.module.css';

interface PlantafelBoardHeaderProps {
  loading: boolean;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  goToPreviousPeriod: () => void;
  goToNextPeriod: () => void;
  goToCurrentPeriod: () => void;
  refresh: () => Promise<void>;
  periodPrefix: string;
  periodLabel: string;
}

export function PlantafelBoardHeader({
  loading,
  viewMode,
  setViewMode,
  goToPreviousPeriod,
  goToNextPeriod,
  goToCurrentPeriod,
  refresh,
  periodPrefix,
  periodLabel,
}: PlantafelBoardHeaderProps): React.JSX.Element {
  return (
    <div className={styles.headerBar}>
      <div className={styles.headerNavGroup}>
        <button
          onClick={goToPreviousPeriod}
          className={styles.navButton}
          data-testid="plantafel-prev-week"
        >
          <FaChevronLeft size={10} />
        </button>
        <button
          onClick={goToCurrentPeriod}
          className={styles.todayButton}
        >
          Heute
        </button>
        <button
          onClick={goToNextPeriod}
          className={styles.navButton}
          data-testid="plantafel-next-week"
        >
          <FaChevronRight size={10} />
        </button>
      </div>

      <div className={styles.viewSwitcherGroup}>
        {(['week', 'month', 'year'] as ViewMode[]).map((mode) => (
          <button
            key={mode}
            onClick={() => setViewMode(mode)}
            className={`${styles.viewModeButton} ${viewMode === mode ? styles.viewModeButtonActive : styles.viewModeButtonInactive}`}
          >
            {mode === 'week' && 'Woche'}
            {mode === 'month' && 'Monat'}
            {mode === 'year' && 'Jahr'}
          </button>
        ))}
      </div>

      <div className={styles.periodLabel} data-testid="plantafel-week-display">
        {periodPrefix}{periodLabel}
      </div>

      <div className={styles.refreshGroup}>
        <button
          onClick={refresh}
          disabled={loading}
          className={`${styles.refreshButton} ${loading ? styles.refreshButtonDisabled : styles.refreshButtonEnabled}`}
        >
          {loading ? <FaSpinner className="spin" size={10} /> : <FaRedo size={10} />}
          Aktualisieren
        </button>
      </div>
    </div>
  );
}
